import React from 'react'
import StatisticsView from './StatisticsViewV2'
import "../styles/index.scss"

class HomeV2 extends React.Component {
    render() {
        return (
            <div className='Home'>
                <StatisticsView/>
            </div>
        )
    }
}

export default HomeV2
